[
	{
		"id": "Road network",
		"type": "line",
		"source": "basemap_roads",
		"source-layer": "basemap_roads",
		"minzoom": 1,
		"layout": {
			"line-cap": "round",
			"line-join": "round",
			"visibility": "visible"
		},
		"paint": {
			"line-color": "hsl(0, 0%, 100%)",
			"line-width": [
				"interpolate",
				["linear"],
				["zoom"],
				1,
				["match", ["get", "functional_road_class"], ["1"], 0.8, 0],
				4,
				["match", ["get", "functional_road_class"], ["1"], 1.3, ["2"], 0.2, 0],
				6,
				["match", ["get", "functional_road_class"], ["1"], 2, ["2"], 1.3, ["3"], 0.8, 0],
				10,
				["match", ["get", "functional_road_class"], ["1"], 3, ["2"], 1.9, ["3"], 1.4, ["4"], 1, 0],
				14,
				["match", ["get", "functional_road_class"], ["1"], 6, ["2"], 4, ["3"], 3, ["4"], 1.5, 0],
				18,
				["match", ["get", "functional_road_class"], ["1", "2", "3"], 8, ["4"], 4, 2]
			],
			"line-offset": 0
		}
	},
	{
		"id": "Road labels",
		"type": "symbol",
		"source": "basemap_roads",
		"source-layer": "basemap_roads",
		"minzoom": 14,
		"layout": {
			"text-font": ["Noto Sans Regular"],
			"text-size": ["interpolate", ["exponential", 1.4], ["zoom"], 14, 10, 17, 12, 20, 15],
			"text-field": ["get", "name"],
			"visibility": "visible",
			"text-anchor": "center",
			"text-overlap": "never",
			"text-padding": 2,
			"symbol-spacing": {
				"stops": [
					[13, 250],
					[20, 350]
				]
			},
			"symbol-z-order": "auto",
			"text-transform": "uppercase",
			"symbol-placement": "line",
			"text-keep-upright": true,
			"symbol-avoid-edges": true,
			"text-radial-offset": 0,
			"text-letter-spacing": 0.1,
			"text-pitch-alignment": "auto",
			"text-rotation-alignment": "map"
		},
		"paint": {
			"text-color": "hsl(0, 0%, 5%)",
			"text-halo-color": "hsl(0, 0%, 100%)",
			"text-halo-width": 2
		},
		"filter": ["!", ["has", "nc_routenumshield"]]
	},
	{
		"id": "Route labels",
		"type": "symbol",
		"source": "basemap_roads",
		"source-layer": "basemap_roads",
		"minzoom": 5,
		"layout": {
			"text-font": ["Lato Italic", "Noto Sans Italic"],
			"text-size": ["interpolate", ["exponential", 1.4], ["zoom"], 7, 13, 13, 14, 20, 16],
			"text-field": ["get", "name"],
			"visibility": "visible",
			"text-anchor": "center",
			"text-overlap": "never",
			"text-padding": 2,
			"symbol-spacing": {
				"stops": [
					[6, 480],
					[20, 640]
				]
			},
			"symbol-z-order": "auto",
			"text-transform": "uppercase",
			"symbol-placement": "line",
			"text-keep-upright": true,
			"symbol-avoid-edges": true,
			"text-radial-offset": 0,
			"text-letter-spacing": 0.1,
			"text-pitch-alignment": "auto",
			"text-rotation-alignment": "map"
		},
		"paint": {
			"text-color": "hsl(0, 0%, 5%)",
			"text-halo-color": "hsl(0, 0%, 100%)",
			"text-halo-width": 2
		},
		"filter": ["has", "nc_routenumshield"]
	}
]
